import zhCN from './json/address.zh_CN.json';
import zhTW from './json/address.zh_TW.json';
import en from './json/address.en.json';
import ja from './json/address.ja.json';
import ko from './json/address.ko.json';
import ru from './json/address.ru.json';
export default {
  zh_CN: zhCN,
  zh_TW: zhTW,
  en,
  ja,
  ko,
  ru
};
